export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_af782719-a3b1-48a1-800a-ff5c79e2e08a/artifacts/vwl47aut_BaltiVex%20logo.png";

export const NAV_LINKS = [
  { to: "/products", label: "Products" },
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/innovation", label: "Innovation" },
  { to: "/sustainability", label: "Sustainability" },
  { to: "/about", label: "About" },
];

export const IMG = {
  hero:
    "https://images.pexels.com/photos/27084598/pexels-photo-27084598.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1100&w=1800",
  polymers1:
    "https://images.pexels.com/photos/15158323/pexels-photo-15158323.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  polymers2:
    "https://images.unsplash.com/photo-1673285092024-9bcd9b3c0e21?auto=format&fit=crop&w=1600&q=80",
  machinery:
    "https://images.pexels.com/photos/18540320/pexels-photo-18540320.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
  lab1:
    "https://images.pexels.com/photos/13949979/pexels-photo-13949979.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  lab2:
    "https://images.pexels.com/photos/8533045/pexels-photo-8533045.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  texture1:
    "https://images.pexels.com/photos/6979822/pexels-photo-6979822.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  texture2:
    "https://images.pexels.com/photos/4571253/pexels-photo-4571253.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1200",
  industrial1:
    "https://images.unsplash.com/photo-1565374395542-0ce18882c857?auto=format&fit=crop&w=1600&q=80",
  industrial2:
    "https://images.unsplash.com/photo-1581094288338-2314dddb7ece?auto=format&fit=crop&w=1600&q=80",
  microscope:
    "https://images.unsplash.com/photo-1576086213369-97a306d36557?auto=format&fit=crop&w=1600&q=80",
  pellets:
    "https://images.unsplash.com/photo-1582719471384-894fbb16e074?auto=format&fit=crop&w=1600&q=80",
  wood:
    "https://images.unsplash.com/photo-1542273917363-3b1817f69a2d?auto=format&fit=crop&w=1600&q=80",
  printing:
    "https://images.unsplash.com/photo-1631452180519-c014fe946bc7?auto=format&fit=crop&w=1600&q=80",
  factory:
    "https://images.unsplash.com/photo-1518709268805-4e9042af2176?auto=format&fit=crop&w=1600&q=80",
  baltic:
    "https://images.unsplash.com/photo-1518684079-3c830dcef090?auto=format&fit=crop&w=1600&q=80",
};
